import React from "react"
import {
  Modal,
  Box,
  Button,
  Typography,
  Fade,
  Zoom,
  Backdrop,
  Divider,
} from "@mui/material"
import DataMappingIcon from "../../icons/harmonization/DataMapping.svg"
import DataMappingExitIcon from "../../icons/harmonization/DataMappingExit.svg"

const MappingWarningModal = ({
  title = "GenAI Mapping",
  isOpen,
  onClick,
  isDuplicateMapping,
}: any) => {
  const getModalMessage = () => {
    if (isDuplicateMapping) {
      return (
        <>
          The mapping for the selected scenario already exists in our system.
          Would you like to review or update it?{" "}
          <span style={{ fontWeight: 600 }}>click Go to mapping</span> to start
          updating.
        </>
      )
    }
    return (
      <>
        You are about to create a new mapping for your selected scenario. Please
        note that{" "}
        <span style={{ fontWeight: 600 }}>
          this process might take some time to complete.
        </span>
      </>
    )
  }

  const getActionButtonText = () =>
    isDuplicateMapping ? "Go to Mapping" : "Yes, Create Mapping"

  const handleButtonClick = (action?: string) => () => onClick(action)

  const modalStyle = {
    display: "flex",
    flexDirection: "column",
    width: 562,
    height: 396,
    bgcolor: "background.paper",
    boxShadow: 24,
    px: 3,
    py: 2.5,
    borderRadius: 3,
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  }

  const buttonStyle = {
    textTransform: "none",
    fontSize: "11px",
    fontWeight: 600,
    flex: 1,
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleButtonClick("cancel")}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Fade in={isOpen}>
        <Box sx={modalStyle}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography variant="h6">{title}</Typography>
            <Divider />
          </Box>

          <Zoom in={isOpen} style={{ marginTop: "16px", marginBottom: "20px" }}>
            <img
              src={isDuplicateMapping ? DataMappingExitIcon : DataMappingIcon}
              alt="Data Mapping"
              style={{ height: 174, margin: "auto" }}
            />
          </Zoom>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              mt: 0.5,
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                alignItems: "center",
              }}
            >
              <Typography variant="subtitle1" sx={{ fontSize: 14 }}>
                {isDuplicateMapping
                  ? "Mapping Already Exists"
                  : "Create New Mapping"}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  fontSize: 13,
                  textAlign: "center",
                }}
              >
                {getModalMessage()}
              </Typography>
            </Box>

            <Box display="flex" gap={1.25} px={2}>
              <Button
                variant="outlined"
                size="small"
                sx={{
                  ...buttonStyle,
                  color: "#000",
                }}
                onClick={handleButtonClick("cancel")}
              >
                {isDuplicateMapping ? "Cancel" : "No, Cancel"}
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{
                  ...buttonStyle,
                  color: isDuplicateMapping ? "#000" : "#fff",
                  backgroundColor: isDuplicateMapping
                    ? "customColors.buttonBackgroundGrey"
                    : "",
                  ":hover": {
                    backgroundColor: isDuplicateMapping
                      ? "customColors.buttonBackgroundGrey"
                      : "",
                  },
                  boxShadow: 0,
                }}
                onClick={handleButtonClick(
                  isDuplicateMapping ? "home" : "proceed",
                )}
              >
                {getActionButtonText()}
              </Button>
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  )
}

export default MappingWarningModal
